// ============================================================
// Braval - Landing Page
// ============================================================

import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../App';

export default function LandingPage() {
    return (
        <div className="app-layout">
            <Header />
            <main className="landing-body">
                <div className="landing-welcome">
                    <h2 className="landing-heading">Branford Valuations - Master Database</h2>
                    <p className="landing-subheading">Select a tool to get started.</p>
                </div>
                <div className="landing-cards">
                    <Link to="/auctions" className="landing-card">
                        <div className="landing-card-title landing-card-title-centered">Auction Database</div>
                        <div className="landing-card-desc">Browse a list of Auction Projects that TBG has gathered data on, including Lot Descriptions, Bid Counts, and Hammer Price.</div>
                    </Link>
                    <Link to="/comps" className="landing-card">
                        <div className="landing-card-title landing-card-title-centered">Comps Database</div>
                        <div className="landing-card-desc">Search a vast range of Lot Data spanning the past thirty years, including our own auctions and other notable results.</div>
                    </Link>
                    <Link to="/auctions/new" className="landing-card">
                        <div className="landing-card-title landing-card-title-centered">Load New Comps</div>
                        <div className="landing-card-desc">Create a new Auction Project and import lot data via Excel.</div>
                    </Link>
                </div>
            </main>
        </div>
    );
}
